export const filterFormatter = data => {
	switch (data.field) {
		case 'PmscrfiStatusDesc':
			return `,rfiStatus=${data.operator}`;

		case 'DmiStatusDesc':
			return encodeURI(`,statusCode="${data.operator}"`);

		case 'DmiPriorityDesc':
			return `,priorityCode=${data.operator}`;

		case 'DmiTypeCode':
			return `,typeCode=${data.operator}`;

		case 'PmjPrepContactName':
			return `,contactpartnTcode=${data.operator}`;

		case 'PmjRainDayFlag':
			return `,rainflag=${data.operator}`;

		case 'PmjRecordStatus':
			return `,journalStatus=${data.operator}`;

		default:
			return '';
			break;
	}
};

export const filterOptionsFormatter = data => {
	if (!data) return null;
	return data.map(item => ({
		...item,
		getApplyFilterFn: filterItem => {
			if (!filterItem.field || !filterItem.value || !filterItem.operator) {
				return null;
			}

			return params => {
				return params.value == filterItem.value;
			};
		},
	}));
};
